// import "antd/dist/antd.less";
import React, {
  useMemo,
  useRef,
  useState,
  useEffect, 
  useCallback
} from "react";
import useApi from "../useApi.mjs";
import { PreviewWidget } from "@/pages/MainPage/frames/Formily/widgets";
import Iframe from "@/pages/MainPage/frames/FormilyMobile/FormilyIframe";
import { transformToTreeNode } from "@designable/formily-transformer";
import { Link, useNavigate, useNavigation } from "react-router-dom";
import { getNavObj } from '../util.js'
import EventModal from './EventModal.jsx';
import openWindow from '@/script/openWindow.mjs';
import {ModalPreviewUv} from './PreviewImage.jsx'
import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import updateChildBoxWithFormily from '../SchemaMerger.ts';
import ShcemaDataPreview from '../schemaDataPreview.jsx';


const PreviewContent = ({ shcemaData, current, uvObj={}, scaleNum, ...props }) => {
    const api = useApi();
    const params = new URLSearchParams(location.search.split("?")[1]);
    const uvMode = params.get("uvMode") ? Number(params.get("uvMode")) : 2;
    const actionRef = useRef(null)
    const openModal = useOpenModal()

    const iframeRef = useRef(null);
    const modalRef = useRef(null)
    const navigate = useNavigate();

    useEffect(() => {
      if(uvObj.uiId) fetchData(uvObj.uiId);
    }, [uvObj.uiId]);
  
    const fetchData = async (id) => {
      const data = await api.fetchUmues({pkid: id});
      actionRef.current = data;
    };

    const handlNavigate = (obj) => {
      // 将查询字符串分割成键值对
      const queryParams = obj.search?.split("&");
      // 创建一个空对象来存储结果
      const result = {};
      // 遍历键值对，并将其添加到对象中
      queryParams.forEach((param) => {
        const [key, value] = param.split("=");
        result[key] = decodeURIComponent(value);
      });
      navigate(obj);
    };

    const jsonObject = {};
    for (const [key, value] of params.entries()) {
      jsonObject[key] = value;
    }

    // 添加一个新的状态到历史栈顶
    const pushToHistory = (id) => {
      const navObj = getNavObj({uvId: id})
      handlNavigate(navObj);
    };

    const handleCtrlClick = async (obj) => {
      const { type, id } = obj;
      modalRef.current?.handleCtrlClick({
        type,
        id
      })
    };

    const handleUeClick = useCallback(async (obj={}) => {
        const { id } = obj;
        if(!id) return;
        const actionData = actionRef.current || [];
        const currActionData = actionData.find(item => item.pkid === id);

        handleFetchUv(currActionData)
      }, [])

      const handleNav = (uvData) => {
          let navObj
          if(uvData.bizNodeType == 'UV') {
            navObj = getNavObj({uvId: uvData.pkid})
          } else {
            navObj = getNavObj({uiId: uvData.pkid})
          }
          // navigate(navObj);
          if(uvData.oprType == 'POP') {
            // 使用 URLSearchParams 解析
            const searchParams = new URLSearchParams(navObj.search);
            // 将迭代器转换为对象
            const paramsObject = Object.fromEntries(searchParams.entries());
            openWindow(navObj.pathName, paramsObject, '_blank')
          } else {
            navigate(navObj);
          }
        }
      
        const handleFetchUv = async (data) => {
          const pkid = data.pkid;
          if(!data.views?.length) return;
          const res = data.views || [];
          const directViews =  res.filter(item => item.isDirect) || []
          // 如果能力下直接挂载了指定的视图，就默认直接跳转
          if(!!directViews.length) {
            const uvData = directViews[0].data || directViews[0];
            handleNav({...uvData, oprType: directViews[0].oprType || 'UI'});
            return;
          }
      
          const uiIds = res.map(item =>{
            if(item.bizNodeType == 'UI') return item.pkid;
            if(item.bizNodeType == 'UV') return item.uiId;
          }) || [];
          // 去重uiIds
          const uiIdSet = [...new Set(uiIds)];
      
          if(uiIdSet.length == 1 ) {
            if (res.length == 1) {
              const uvData = res[0];
              handleNav(uvData)
            } else {
              openModal(
                <ModalPreviewUv
                    handleNav={handleNav}
                    uvs={res}
                />
              )
            }
          }else{
            handleCtrlClick({
              type: 'UE',
              id: pkid
            })
          }
        }

    const tree = useMemo(() => {
      const uvMap = shcemaData && shcemaData.uvMap
        ? JSON.parse(shcemaData.uvMap)
        : {};
      const parentUvMap = shcemaData && shcemaData.pUvMap
        ? JSON.parse(shcemaData.pUvMap)
        : {};

      const childUvNode = transformToTreeNode(uvMap);

      let resultNode = childUvNode;
      if(parentUvMap.schema) {
        const parentUvNode = transformToTreeNode(parentUvMap);
        resultNode = updateChildBoxWithFormily(parentUvNode, childUvNode.children)
      }
       
      return resultNode || childUvNode;
    }, [shcemaData.uvMap]);
    return (
      <>
        {/* 测试用 */}
        {/* <ShcemaDataPreview shcemaData={shcemaData} uvMode={uvMode} /> */}
        <section className="formily-preview-content">
          {shcemaData.uvType == "MOBILE" ? (
            <div className="formily-preview-content-wrapper">
              <div
                style={{
                  transform: `scale(${scaleNum})`,
                  transformOrigin: scaleNum <= 1 ? "center" : "top center",
                }}
                className="formily-preview-content-mobile"
              >
                <img
                  className="mobile-img"
                  src="//img.alicdn.com/imgextra/i4/O1CN01ehfzMc1QPqY6HONTJ_!!6000000001969-55-tps-459-945.svg"
                  alt=""
                />
                <div className="mobile-content">
                  <div
                    style={{
                      overflow: "overlay",
                      height: "100%",
                      cursor: "auto",
                      userSelect: "text",
                    }}
                  >
                    <Iframe
                      ref={iframeRef}
                      tree={tree}
                      changeData={pushToHistory}
                      handleCtrlClick={handleCtrlClick}
                      handleUeClick={handleUeClick}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <PreviewWidget
              {...props}
              uvMode={uvMode}
              handleCtrlClick={handleCtrlClick}
              handleUeClick={handleUeClick}
              handlNavigate={handlNavigate}
              tree={tree}
              initParms={jsonObject}
            />
          )}
        </section>
        {
          (!shcemaData.uvMap) && <div className="no-image-wrapper">
            <div className='no-image'><div>{shcemaData.uiName}</div></div>
          </div>
        }
        <EventModal ref={modalRef} />
      </>
    );
}


export default PreviewContent;
